/**
 * src/components/ui/StatusBadge.jsx — coloured status indicator.
 *
 * Replaces components/ui.jsx's old `Pill` (still exported from there as a
 * thin wrapper around this, so its ~7 existing callers needed no changes —
 * see that file). The one real behaviour change: every status now carries a
 * glyph alongside its colour and text, per REDESIGN.md's Accessibility
 * standard ("status is never colour-only"). The glyphs (✓ ⚠ ✕ •) match the
 * ones `.calendar-event.event-completed`/`.event-no_show` already use in
 * styles.css — established precedent in this exact codebase, not a new
 * convention — and are plain typographic marks, not emoji (REDESIGN.md's
 * banned list is specifically about emoji-as-icons).
 */

const STATUS_GLYPH = {
  confirmed: '✓',
  signed: '✓',
  complete: '✓',
  completed: '✓',
  available: '✓',
  pending: '⚠',
  active: '⚠',
  claimed: '⚠',
  cancelled: '✕',
  expired: '✕',
  no_show: '✕',
  sold: '•',
  paused: '•',
};

/**
 * @param {{ status: string|null|undefined }} props
 * @returns {JSX.Element|null}
 */
export function StatusBadge({ status }) {
  if (!status) return null;
  const glyph = STATUS_GLYPH[status] ?? '•';
  return (
    <span className={`pill pill-${status}`}>
      <span aria-hidden="true">{glyph}</span> {status.replace(/_/g, ' ')}
    </span>
  );
}
